var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ai_modal_container"},[_c('Header',{attrs:{"title":_vm.title,"onClose":_vm.handleClose}}),_vm._v(" "),_c('div',{class:"ai_modal_content_wrapper modal_content_padding"},[(_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.formattedContent)}}):_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14bf9614","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ai/term/AiTerm1.vue
// module id = null
// module chunks = 